import { Component, HostBinding, input, Input } from '@angular/core';
import { Offer } from '@innogy/become-a-customer/shared/interfaces';
import {
  SkeletonLoaderMask,
  SvgSkeletonLoaderComponent,
} from '@legacy/common-ui-shared';

import { cardMask } from '../svg-skeleton-masks';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'wl-commodity-offer-card',
  templateUrl: './commodity-offer-card.component.html',
  styleUrls: [
    './commodity-offer-card.component.ed.scss',
    './commodity-offer-card.component.essent.scss',
  ],
  standalone: true,
  imports: [CommonModule, SvgSkeletonLoaderComponent],
})
export class CommodityOfferCardComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() offer?: Offer;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() showLoadingState = false;

  readonly isQuestionnaireVariant = input(false);

  @HostBinding('attr.data-offerid')
  get offerId() {
    return this.offer?.offerId;
  }

  get mask(): SkeletonLoaderMask {
    return cardMask;
  }
}
